import { render, staticRenderFns } from "./data-service1.vue?vue&type=template&id=c7a4c208&scoped=true"
import script from "./data-service1.vue?vue&type=script&lang=js"
export * from "./data-service1.vue?vue&type=script&lang=js"
import style0 from "./data-service1.vue?vue&type=style&index=0&id=c7a4c208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a4c208",
  null
  
)

export default component.exports